import type Map from 'ol/Map'
import { createMeasure, type MeasureMode, type MeasureTool } from '../map/measure'

const UNIT_OPTIONS: Record<MeasureMode, Array<{ value: string; label: string }>> = {
  distance: [
    { value: 'km', label: 'km' },
    { value: 'm', label: 'm' },
  ],
  area: [
    { value: 'km2', label: 'km²' },
    { value: 'ha', label: 'ha' },
    { value: 'm2', label: 'm²' },
  ],
}

/**
 * Contents of the toolbar's "Measure" panel (PRD P1.2): distance/area mode
 * toggles, a per-mode unit selector, and a clear button for finished
 * measurements. The panel itself belongs to `mapToolbar` (T4).
 */
export function renderMeasureBar(panel: HTMLElement, map: Map): MeasureTool {
  panel.innerHTML = `
    <button type="button" class="measure-btn" id="measure-distance" title="Measure distance">Distance</button>
    <button type="button" class="measure-btn" id="measure-area" title="Measure area">Area</button>
    <select class="measure-units" id="measure-units" aria-label="Measurement units" hidden></select>
    <button type="button" class="measure-btn" id="measure-clear" title="Remove all measurements" hidden>Clear</button>`

  const btnDistance = panel.querySelector('#measure-distance') as HTMLButtonElement
  const btnArea = panel.querySelector('#measure-area') as HTMLButtonElement
  const unitSelect = panel.querySelector('#measure-units') as HTMLSelectElement
  const btnClear = panel.querySelector('#measure-clear') as HTMLButtonElement

  let syncUi: (mode: MeasureMode | null) => void = () => {}
  const measure = createMeasure(map, (mode) => syncUi(mode))

  syncUi = (mode) => {
    btnDistance.classList.toggle('measure-btn--active', mode === 'distance')
    btnArea.classList.toggle('measure-btn--active', mode === 'area')
    unitSelect.hidden = mode === null
    if (mode) {
      unitSelect.innerHTML = ''
      for (const opt of UNIT_OPTIONS[mode]) {
        const option = document.createElement('option')
        option.value = opt.value
        option.textContent = opt.label
        unitSelect.appendChild(option)
      }
    }
    btnClear.hidden = mode === null && !measure.hasResults()
  }

  btnDistance.addEventListener('click', () => measure.setMode('distance'))
  btnArea.addEventListener('click', () => measure.setMode('area'))
  unitSelect.addEventListener('change', () => {
    if (measure.mode() === 'distance') measure.setDistanceUnit(unitSelect.value as 'km' | 'm')
    else measure.setAreaUnit(unitSelect.value as 'km2' | 'ha' | 'm2')
  })
  btnClear.addEventListener('click', () => {
    measure.clear()
    syncUi(measure.mode())
  })

  return measure
}
